import {
  Money,
  CurrencyBtc,
  Briefcase,
  Buildings,
  Car,
  Coins,
  Diamond,
  Bank,
  PiggyBank,
  Wallet,
} from '@phosphor-icons/react';

import pt from '../../locales/pt';

/**
 * Asset categories declared by the backend `AssetCategory` choices.
 * Order matters — it drives the grouping of `Accounts.jsx`.
 *
 * CHANGE v2 §8: backend mantém todos os choices; o frontend usa este array
 * apenas para o picker. As 4 categorias destacadas aparecem em primeiro lugar
 * com sugestões rápidas no form (ver QUICK_NAME_SUGGESTIONS).
 */
export const ASSET_CATEGORIES = [
  { value: 'bank_account', icon: Bank, color: '#6B8FA8' },
  { value: 'savings_account', icon: PiggyBank, color: '#7C9E6F' },
  { value: 'brokerage', icon: Briefcase, color: '#6B8FA8' },
  { value: 'crypto', icon: CurrencyBtc, color: '#D4A574' },
  { value: 'cash', icon: Money, color: '#7C9E6F' },
  { value: 'real_estate', icon: Buildings, color: '#A67C52' },
  { value: 'precious_metal', icon: Diamond, color: '#C7A77A' },
  { value: 'vehicle', icon: Car, color: '#9CA3AF' },
  { value: 'business', icon: Briefcase, color: '#6B8FA8' },
  { value: 'other', icon: Coins, color: '#9CA3AF' },
];

// CHANGE v2 §8: sugestões de nomes rápidas para as 4 categorias principais.
export const QUICK_NAME_SUGGESTIONS = {
  bank_account: ['Conta à ordem', 'Conta principal', 'Revolut'],
  savings_account: ['Conta poupança', 'Fundo de emergência'],
  brokerage: ['Corretora ETFs', 'Degiro', 'Trading 212'],
  crypto: ['BTC', 'ETH', 'USDT'],
};

/** Native unit codes for crypto quick picks and ticker inference. */
export const CRYPTO_NATIVE_CODES = ['BTC', 'ETH', 'USDT'];

/**
 * Currency shown in selfie / quantity fields.
 * Legacy crypto accounts may still have currency=EUR; infer from ticker when possible.
 */
export function resolveAccountNativeCurrency(account) {
  const stored = String(account?.currency || 'EUR').toUpperCase();
  if (account?.category !== 'crypto' || stored !== 'EUR') {
    return stored;
  }
  const ticker = String(account?.ticker || '').toUpperCase();
  for (const code of CRYPTO_NATIVE_CODES) {
    if (ticker.startsWith(code)) return code;
  }
  return stored;
}

export function categoryLabel(value) {
  return pt.accounts.categories[value] || value;
}

export function categoryMeta(value) {
  return (
    ASSET_CATEGORIES.find((item) => item.value === value) || {
      value: 'other',
      icon: Wallet,
      color: '#9CA3AF',
    }
  );
}

/** Fields visible in the form per category.
 *
 * CHANGE v2 §8: institution removida.
 */
export function fieldVisibility(category) {
  const base = {
    currency: true,
    ticker: false,
    quantity: false,
    acquisition: false,
  };
  switch (category) {
    case 'crypto':
    case 'brokerage':
    case 'precious_metal':
      return { ...base, ticker: true };
    case 'real_estate':
    case 'vehicle':
    case 'business':
      return { ...base, acquisition: true };
    default:
      return base;
  }
}
